<script setup lang="ts">
import type { FilterCategory, FilterDraft } from '#shared/mobile-filter-drawer'
import { faBuildingColumns } from '@fortawesome/pro-light-svg-icons'

const openFilter = defineModel('openFilter', { default: false })

const { legalAreaOptions, selectedLegalArea, countWithFilters } = useAuthorFilters()

const categories = computed<FilterCategory[]>(() => [{
  id: 'rettsområde',
  label: 'Rettsområde',
  icon: faBuildingColumns,
  options: legalAreaOptions.value,
  resetAriaLabel: 'Nullstill rettsområde',
}])

const initial = computed<FilterDraft>(() => ({
  categories: { rettsområde: selectedLegalArea.value },
  toggles: {},
}))

function count(draft: FilterDraft) {
  return countWithFilters({ selectedLegalArea: draft.categories.rettsområde ?? [] })
}

function onCommit(draft: FilterDraft) {
  selectedLegalArea.value = [...(draft.categories.rettsområde ?? [])]
}
</script>

<template>
  <MobileFilterDrawer
    v-model:open="openFilter"
    :categories="categories"
    :initial="initial"
    :count="count"
    @commit="onCommit"
  />
</template>
